<template>
  <div class="api-item-container">
    首页内容
  </div>
</template>

<script>


export default {
  name: "index",
  data() {
    return {}
  },
  components: {},
  methods: {},
  computed: {},
  created() {
  },
  mounted() {

  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
</style>
